import { useEffect } from 'react';
import { useFetchUserParameters } from '../../../hooks/useFetchUserParameters';
import { useTransactionParameters } from '../../../context/TransactionParameterContext';
import { useFetchUser } from '../../../hooks/useFetchUser';
import { useUser } from '../../../context/UserContext';
import TransactionMail from './transactionMail';
import { Spin } from '../../Ant';

const TransactionInitializer = () => {
  const { data: parametersDetails, isLoading: isParameterLoading } = useFetchUserParameters({
    parametersToGet: 'transaction',
  });
  const { data: userDetails, isLoading: isUserLoading } = useFetchUser(
    {
      relations: ['businessUnit', 'userRole', 'userGroups'],
    },
    {
      enabled: true,
    },
  );
  const { updateUserDetails } = useUser();
  const { updateParameters } = useTransactionParameters();
  useEffect(() => {
    if (parametersDetails) {
      updateParameters(parametersDetails?.parameters?.transactionParameters);
    }
  }, [parametersDetails]);
  useEffect(() => {
    if (userDetails) {
      updateUserDetails(userDetails);
    }
  }, [userDetails]);
  if (isUserLoading || isParameterLoading)
    return <Spin fullscreen data-testid="loading-indicator" />;
  return <TransactionMail />;
};

export default TransactionInitializer;
